export const COMMENT_AGO = 'comment.ago';
export const COMMENT_LIKE = 'comment.like';
export const COMMENT_REPLY = 'comment.reply';
export const COMMENT_REPLIES = 'comment.replies';
